import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const PasswordInput = ({
  name = "password",
  value,
  label = "password",
  onChange,
  onFocus,
  onBlur,
  required = false,
  hasError = false,
  size = "small",
  errorText = "",
  helperText = "",
  ...props
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef();

  const togglePasswordVisibility = () => {
    if (inputRef.current) {
      const start = inputRef.current.selectionStart;
      const end = inputRef.current.selectionEnd;

      setShowPassword((prev) => !prev);

      // Wait for type change to apply, then restore cursor position
      setTimeout(() => {
        try {
          inputRef.current.setSelectionRange(start, end);
        } catch (err) {
          // Avoid crashing on mobile if selection can't be set
        }
      }, 0);
    } else {
      setShowPassword((prev) => !prev);
    }
  };

  const handleFocus = (e) => {
    setError("");

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    if (!value && required) {
      setError(t("error_input_required"));
    }

    if (onBlur) {
      onBlur(e);
    }
  };

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <TextField
      fullWidth
      id="password-input"
      variant="outlined"
      margin="normal"
      type={showPassword ? "text" : "password"}
      size={size}
      name={name}
      value={value}
      label={label}
      error={hasError || !!error}
      helperText={error || errorText || helperText}
      inputRef={inputRef}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={togglePasswordVisibility} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      {...props}
    />
  );
};
